import { UnifyMenu } from '@sop/unify-menu';

export class SystemMenu {
    initialize(menuNodes) {
        this.unifyMenu = new UnifyMenu(menuNodes, document.getElementsByClassName('section-menu-content')[0]);
    }

    setActiveObject(json) {
        this.unifyMenu.setActiveMenuObject(json);
    }

    setActiveNode(json) {
        this.unifyMenu.setActiveMenuObject(json);
    }

    setActiveNodeById(json) {
        this.unifyMenu.setActiveMenuObjectById(json);
    }

    setActiveNodeByUri(json) {
        this.unifyMenu.setActiveMenuObjectByUri(json);
    }

    setMenu(json) {
        this.initialize(json);
    }

    setActiveMenuObject(uriOrMenuId) {
        this.setActiveNode(uriOrMenuId);
    }
}
